import Vue from 'vue';
import Vuex from 'vuex';
import { order } from './order.js';
import { dashboard } from './dashboard.js';
import { language } from './language.js';
import { marketing } from './marketing.js';
import { packaging } from './packaging.js';
import { bulkEdit } from './modules/bulkEdit.js';
import VuexPersistence from 'vuex-persist'


Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  modules: ['order'],
  storage: window.localStorage
})

export default new Vuex.Store({
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    order,
    dashboard,
    language,
    marketing,
    packaging,
    bulkEdit
  },
  plugins: [
    vuexLocal.plugin
  ]
});
